import Worker from './../workers/timer.worker'

/**
 * Wrapper class for the setInterval worker.
 * This will allow the main thread to continue
 * with any necessary updates when the tab goes
 * inactive in the background.
 *
 * @export
 * 
 * @class Timer
 */
export default class Timer {

  /**
   * Creates an instance of Timer.
   *
   * @memberof Timer
   */
  constructor() {
    this._worker = new Worker();
    this._interval = null;
  }

  /**
   * Sets the interval at which the timer should update.
   *
   * @memberof Timer
   * 
   * @param {Number} interval
   * 
   * @returns Void
   */
  setInterval(interval) {
    this._interval = interval;
  }
  
  /**
   * Sets the callback function that should 
   * fire whenever the worker emits a message.
   *
   * @memberof Timer
   * 
   * @param {Function} callback
   * 
   * @returns Void
   */
  listen(callback) {
    this._worker.addEventListener('message', callback);
  }
  
  /**
   * Starts the timer if the desired interval has been set.
   *
   * @memberof Timer
   * 
   * @returns Void
   */
  startTimer() {
    if (this._interval === null) {
      throw new Error('Please set an interval before starting the timer.');
    }

    this._worker.postMessage({
      call: 'startTimer',
      interval: this._interval
    });
  }

  /**
   * Stops the timer and clears the interval from memory.
   *
   * @memberof Timer
   * 
   * @returns Void
   */
  stopTimer() {
    this._worker.postMessage({
      call: 'stopTimer'
    });
  }
}